(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core"], factory);
	else if(typeof exports === 'object')
		exports["ticktock"] = factory(require("@angular/core"));
	else
		root["ticktock"] = factory(root["ng"]["core"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(4));


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
function _window() {
    // return the global native browser window object
    return window;
}
var WindowRef = /** @class */ (function () {
    function WindowRef() {
    }
    Object.defineProperty(WindowRef.prototype, "nativeWindow", {
        get: function () {
            return _window();
        },
        enumerable: true,
        configurable: true
    });
    WindowRef = __decorate([
        core_1.Injectable()
    ], WindowRef);
    return WindowRef;
}());
exports.WindowRef = WindowRef;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = __webpack_require__(1);
exports.ScormWrapperService = services_1.ScormWrapperService;
var scorm_wrapper_module_1 = __webpack_require__(6);
exports.ScormWrapperModule = scorm_wrapper_module_1.ScormWrapperModule;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(5));


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/********************************************************************************
 **
 ** SCORM API Wrapper
 **
 ** Supports:
 **
 ** SCORM 1.2, SCORM 2004.[1]
 **
 ** The following is a porting of the code from the
 ** original angularjs-scorm-wrapper file to Angular with a
 ** number of improvements from
 ** Competentum
 **
 ** The code has been updated to wrap the original functions in
 ** in angular and extend support for SCORM 2004 [4].
 ** It draws upon some of concepts offered in the Pipewerks[3]
 **
 ** The code is served as an Angular service [5].
 **
 ** References/Inspiration:
 **
 ** [1] ADL
 ** http://www.adlnet.gov/scorm
 **
 ** [2] CTC SCORM SCORM 1.2 API wrapper
 ** http://www.adlnet.gov/resources/scorm-1-2-content-packages?type=software_downloads
 **
 ** [3] Pipewerks SCORM wrapper
 ** https://github.com/pipwerks/scorm-api-wrapper
 **
 ** [4] SCORM.com
 ** http://scorm.com/scorm-explained/technical-scorm/run-time/
 **
 ** [5] Angularjs scorm wrapper
 ** https://github.com/patamechanix/angularjs-scorm-wrapper
 **
 ** Copyright (c) Competentum 2017
 ** Copyright (c) Aleksey Klimenko
 ** ---------------------------------------------------------------------------------
 ** License:
 **
 **
 ** Permission is hereby granted, free of charge, to any person obtaining a
 ** copy of this software and associated documentation files (the “Software”),
 ** to deal in the Software without restriction, including without limitation the
 ** rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 ** copies of the Software, and to permit persons to whom the Software is furnished to
 ** do so, subject to the following conditions:
 **
 ** The above copyright notice and this permission notice shall be included in
 ** all copies or substantial portions of the Software.
 **
 ** THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 ** IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 ** FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 ** COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 ** IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 ** CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 **
 *********************************************************************************/
var core_1 = __webpack_require__(0);
var window_ref_1 = __webpack_require__(2);
var ScormWrapperService = /** @class */ (function () {
    function ScormWrapperService(windowRef) {
        this.windowRef = windowRef;
        this.version = 'Auto';
        this.API = null;
        this.scormVersions = ['Auto', '1.2', '2004'];
        this.win = windowRef.nativeWindow;
    }
    ScormWrapperService.prototype.setAPIVersion = function (scormVersion) {
        scormVersion = scormVersion || 'Auto';
        var v = this.scormVersions.indexOf(scormVersion.toString());
        (v > -1) ? this.version = this.scormVersions[v] : console.log('Not found, default to Auto');
        return this.version;
    };
    Object.defineProperty(ScormWrapperService.prototype, "APIVersion", {
        get: function () {
            return this.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScormWrapperService.prototype, "isAvailable", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScormWrapperService.prototype, "LMSIsInitialized", {
        get: function () {
            return this.API;
        },
        enumerable: true,
        configurable: true
    });
    ScormWrapperService.prototype.doLMSInitialize = function () {
        return this.cmiBooleanToJs(this.getAPICall('LMSInitialize', 'Initialize')(''));
    };
    ScormWrapperService.prototype.doLMSFinish = function () {
        return this.cmiBooleanToJs(this.getAPICall('LMSFinish', 'Terminate')(''));
    };
    ScormWrapperService.prototype.doLMSGetValue = function (parameter) {
        return this.getAPICall('LMSGetValue', 'GetValue')(parameter);
    };
    ScormWrapperService.prototype.doLMSSetValue = function (parameter, value) {
        return this.cmiBooleanToJs(this.getAPICall('LMSSetValue', 'SetValue')(parameter, value));
    };
    ScormWrapperService.prototype.doLMSCommit = function () {
        return this.cmiBooleanToJs(this.getAPICall('LMSCommit', 'Commit')(''));
    };
    ScormWrapperService.prototype.doLMSGetLastError = function () {
        return this.getAPICall('LMSGetLastError', 'GetLastError')();
    };
    ScormWrapperService.prototype.doLMSGetErrorString = function (errorCode) {
        return this.getAPICall('LMSGetErrorString', 'GetErrorString')(errorCode.toString());
    };
    ScormWrapperService.prototype.doLMSGetDiagnostic = function (errorCode) {
        return this.getAPICall('LMSGetDiagnostic', 'GetDiagnostic')(errorCode.toString());
    };
    ScormWrapperService.prototype.ErrorHandler = function () {
        return this.getAPICall('LMSGetLastError', 'GetLastError')();
    };
    ScormWrapperService.prototype.cmiBooleanToJs = function (value) {
        return (value === '1' || value === 1 || value === 'true' || value === true);
    };
    ScormWrapperService.prototype.getAPIHandle = function () {
        if (this.win.parent && this.win.parent !== this.win) {
            this.findAPI(this.win.parent);
        }
        if (!this.API && this.win.top.opener) {
            this.findAPI(this.win.top.opener);
        }
        else if (!this.API) {
            console.log('Unable to find API adapter');
        }
    };
    ScormWrapperService.prototype.getAPICall = function (funcname12, funcname2004) {
        if (!this.API) {
            this.getAPIHandle();
            if (!this.API) {
                return function () { return console.log("No API found, can't execute: " + funcname12 + " or " + funcname2004); };
            }
        }
        var API = this.API;
        switch (this.version) {
            case '2004':
                return function () {
                    return API[funcname2004].apply(API, arguments);
                };
            case '1.2':
                return function () {
                    return API[funcname12].apply(API, arguments);
                };
        }
    };
    ScormWrapperService.prototype.findAPI = function (win) {
        var findAttempts = 0;
        var findAttemptLimit = 500;
        for (findAttempts; findAttempts < findAttemptLimit; findAttempts++) {
            if (win.API && (this.version === '1.2' || this.version === 'Auto')) {
                this.API = win.API;
                this.version = '1.2';
                break;
            }
            else if (win.API_1484_11 && (this.version === '2004' || this.version === 'Auto')) {
                this.API = win.API_1484_11;
                this.version = '2004';
                break;
            }
            else if (win.parent && win.parent !== win) {
                findAttempts++;
                win = win.parent;
            }
        }
    };
    ScormWrapperService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [window_ref_1.WindowRef])
    ], ScormWrapperService);
    return ScormWrapperService;
}());
exports.ScormWrapperService = ScormWrapperService;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var services_1 = __webpack_require__(1);
var window_ref_1 = __webpack_require__(2);
var ScormWrapperModule = /** @class */ (function () {
    function ScormWrapperModule() {
    }
    ScormWrapperModule = __decorate([
        core_1.NgModule({
            providers: [
                services_1.ScormWrapperService,
                window_ref_1.WindowRef
            ],
            exports: []
        })
    ], ScormWrapperModule);
    return ScormWrapperModule;
}());
exports.ScormWrapperModule = ScormWrapperModule;


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.umd.min.js